// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5215":"a2f5de32","8688":"c979e12a","9691":"f8197667"}[chunkId] + ".chunk.css";
};